import { __extends } from "tslib";
import { PutBucketTaggingRequest } from "../models/index";
import { deserializeAws_restXmlPutBucketTaggingCommand, serializeAws_restXmlPutBucketTaggingCommand, } from "../protocols/Aws_restXml";
import { getApplyMd5BodyChecksumPlugin } from "@aws-sdk/middleware-apply-body-checksum";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutBucketTaggingCommand = /** @class */ (function (_super) {
    __extends(PutBucketTaggingCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutBucketTaggingCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutBucketTaggingCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        this.middlewareStack.use(getApplyMd5BodyChecksumPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: PutBucketTaggingRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutBucketTaggingCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutBucketTaggingCommand(input, context);
    };
    PutBucketTaggingCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutBucketTaggingCommand(output, context);
    };
    return PutBucketTaggingCommand;
}($Command));
export { PutBucketTaggingCommand };
//# sourceMappingURL=PutBucketTaggingCommand.js.map